export default __webpack_public_path__ + "static/media/logo-brasilp.c3d8ee99.png";